import assertClassBrand from "./assertClassBrand.js";
export default function _classPrivateFieldSet2(s, a, r) {
  return s.set(assertClassBrand(s, a), r), r;
}